import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import alarmsActions from '@state/alarms/actions';

function useCondicionesAlarma({ form }) {

  const dispatch = useDispatch();

  const conditions = useSelector(({ alarms: a }) => a.createEditValues.conditions);
  const origin = useSelector(({ alarms: a }) => a.createEditValues.origin);
  const isEditDefault = useSelector(({ alarms }) => alarms.isEditDefault);

  const [geofences, setGeofences] = useState({ next: null, results: null });

  const addNewGroupConditions = useCallback(() => {

    dispatch(alarmsActions.addCreateEditValuesGroupConditions());

  }, [dispatch]);

  const removeGroupCondition = useCallback((index) => {

    dispatch(alarmsActions.removeCreateEditValuesGroupConditions(index));

  }, [dispatch]);

  useEffect(() => {

    if (conditions.length === 0) addNewGroupConditions();
    // eslint-disable-next-line
  }, []);

  return {
    conditions,
    origin,
    addNewGroupConditions,
    removeGroupCondition,
    geofences,
    setGeofences,
    isEditDefault,
  };

}

export default useCondicionesAlarma;
